/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components

// Composables
import { createApp } from "vue";
import { createPinia } from "pinia"; // Import

// Plugins
import { registerPlugins } from "@/plugins";
import AppVue from "./App.vue";

// Base CSS
import "./assets/base.css";

// import router
import router from "./router/index"; // Import the router instance″
import keycloakService from "./services/keycloak-service";

// Import the environment variables
const mockUsername = import.meta.env.VITE_MOCK_USER;
const mockPassword = import.meta.env.VITE_MOCK_PASSWORD;

// console.log("Mock Username:", mockUsername);
// console.log("Mock Password:", mockPassword);

const app = createApp(AppVue);

// create root store
const pinia = createPinia();
app.use(pinia);

app.use(router);

// Setup auth directives AFTER Pinia is installed
import { setupAuthDirectives } from "./directives/auth";
setupAuthDirectives(app);

registerPlugins(app);

// necessary to make global configs visible
declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    $config: Record<string, unknown>;
  }
}
export {}; // Important! See note.
app.mount("#app");
